
import base from "./base.service"


const addjob = payload => base.post('/jobs/addJob', payload)

const clientJob = payload => base.get('/jobs/clientJobs', { params: payload })

const clientJobDetails = id => base.get(`/jobs/job/${id}`,)

const jobBidList = jobId => base.get(`/jobs/jobBids?jobId=${jobId}`)

const jobBidDetails = jobBidId => base.get(`/jobs/jobBid/${jobBidId}`)

const getPilotJobs = payload => base.get("/jobs/pilotJobs", { params: payload });

const getPilotAvailableJobs = payload => base.get(`/jobs/availableJobsForPilot?skip=${payload?.skip}&limit=${payload?.limit}`);

const addBid = payload => base.post("/jobs/addBid", payload);

const getPilotBids = payload => base.get(`/jobs/pilotBids?skip=${payload?.skip}&limit=${payload?.limit}`);

const negotiateBid = payload => base.post("/jobs/negotiateBid", payload);

const updateBidStatus = payload => base.post("/jobs/updateBidStatus", payload);
const yearFilter = payload => base.get(`/jobs/clientJobs?year=${payload}`)
const startJob = payload => base.post("/jobs/startJob", payload);
const raiseDispute = payload => base.post('/jobs/raiseDispute', payload)
const markCompleted = payload => base.post('jobs/markJobCompleted', payload)
const DownloadReport = jobId => base.get(`jobs/downloadReport/${jobId}`, {
    responseType: "blob"
})

const clientPostedJobs = () => base.get('jobs/client-posted-jobs')
const sendRequestedJobs = payload => base.post('/jobs/send-requested-jobs', payload)
export const jobService = {
    addjob,
    clientJob,
    clientJobDetails,
    jobBidList,
    jobBidDetails,
    updateBidStatus,
    getPilotJobs,
    getPilotAvailableJobs,
    addBid,
    getPilotBids,
    negotiateBid,
    updateBidStatus,
    startJob,
    raiseDispute,
    markCompleted,
    yearFilter,
    DownloadReport,
    clientPostedJobs,
    sendRequestedJobs,
}